/*
 * @Author: 廿夕 xuanwei@cai-inc.com
 * @Date: 2023-10-11 14:10:14
 * @LastEditors: 廿夕 xuanwei@cai-inc.com
 * @LastEditTime: 2023-10-11 14:13:31
 * @FilePath: /zcy-claim-front/src/routes/PurchaseWorkbench/models/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  namespace: 'purchaseWorkbench',
  state: {},
  reducers: {},
  effects: {},
  subscriptions: {},
}